(function (root) {
  'use strict';
  if (root.JEWeddingCart) return;
  root.JEWeddingCart = Object.freeze({ tokenProperty: '_Wedding submission', payloadProperty: '_Wedding payload',
    create(config = {}) {
      if (!root.JEBirthflowerCart?.create) throw new Error('The cart tools did not load. Refresh the page to try again.');
      return root.JEBirthflowerCart.create({ ...config, kind: 'wedding' });
    }
  });
})(typeof globalThis !== 'undefined' ? globalThis : this);
